import React, { useContext } from 'react';
import Moment from 'react-moment';

import { LocaleContext } from 'context/LocaleContext';

const DateTime = ({ format, children }) => {
    const locale = useContext(LocaleContext);

    return <Moment format={locale.dateTimeFormats[format] || format}>{ children }</Moment>;
}

export default DateTime;
